<template>
  <div ref="box" class="box">
    <div class="canvasBox" ref="canvasBox">
      <canvas ref="canvas" width="1200" :height="cHeight" tabindex="0"></canvas>
      <div ref="vertical" :class="dialog ? 'vScroll vScroll-dialog' : 'vScroll'" v-show="showVScrollbar">
        <div
          ref="vScrollbar"
          class="vScrollBar"
          :class="scroll.vScrolling ? 'scrolling' : ''">
        </div>
      </div>
      <div class="divideTag" ref="divideTag" v-show="showDivideTag">
        <div class="divideLine" ref="divideLine" v-show="showDivideLine"></div>
      </div>
    </div>
    <div
      ref="horizontal"
      :class="dialog ? 'hScroll-dialog' : 'hScroll'"
      :style="hScrollStyle">
      <div ref="hScrollbar" v-show="showHScrollbar" class="hScrollBar"></div>
    </div>
    <input
      ref="editCell"
      class="input-content"
      readonly
      :style="editCellStyle"
      :value="editPosition.text" />
    <tooltip
      :arrow="false"
      :content="tooltip.content"
      :left="tooltip.left"
      :top="tooltip.top"
      :isLast="tooltip.isLast"
      :dialog="dialog"
      :show="tooltip.show" />
    <!--<tooltip
      :left="slotTooltip.left"
      :dialog="dialog"
      :top="slotTooltip.top"
      :show="slotTooltip.show">
      <slot name="tooltip"></slot>
    </tooltip>-->
      <header-tip
        ref="headerTip"
        :content="headerTip.content"
        :left="headerTip.left"
        :top="headerTip.top"
        :show="headerTip.show" />
    <canvas ref="textCanvas" width="0" height="0" style="display:none;"></canvas>
  </div>
</template>

<script>
  import { debounce } from 'lodash'
  import mixins from './mixins'
  import Tooltip from './tooltip'
  import HeaderTip from './header-tip'
  import { btnColor, headerHeight, headerColor, headerTextColor, tableTextColor, rowHeight, lineColor, activeRowColor } from './config'
  import { canavsCalculateAuthPlugin } from './helps/btn-auth'
  import { isErp2 } from 'public/utils/common'
  let getHeight = function (headerHeight) {
    return headerHeight + 10 * this.rowHeight
  }
  let DEFAULT_HEIGHT = headerHeight + 10 * rowHeight
  export const DATE_FILTERS = ['date', 'time', 'minute', 'second', 'month']
  const getKeys = obj => obj ? Object.keys(obj) : []
  export default {
    name: 'kye-canvas-table',
    mixins: mixins,
    components: { Tooltip, HeaderTip },
    props: {
      column: {
        type: Array,
        default () {
          return {}
        }
      },
      data: {
        type: Array,
        default () {
          return []
        }
      },
      operation: {
        type: Object,
        default () {
          return {}
        }
      },
      options: {
        type: Object,
        default () {
          return {}
        }
      },
      buttonOptions: {
        type: Object,
        default () {
          return {}
        }
      },
      imageOptions: {
        type: Object,
        default () {
          return {}
        }
      },
      checkedOptions: {
        type: Object,
        default () {
          return {}
        }
      },
      uploadOptions: {
        type: Object,
        default () {
          return {}
        }
      },
      sortOptions: {
        type: Object,
        default () {
          return {}
        }
      },
      drawColumnOptions: {
        type: Object,
        default () {
          return {}
        }
      },
      layerColumnOptions: {
        type: Object,
        default () {
          return {}
        }
      },
      headRenderOptions: {
        type: Object,
        default () {
          return {}
        }
      },
      headerTipOptions: {
        type: Object,
        default () {
          return {}
        }
      },
      height: {
        type: [String, Number],
        default: DEFAULT_HEIGHT
      },
      page: {
        type: Object,
        default () {
          return {
            pageSize: this.$pagination.pageSize,
            currentPage: 1,
            total: 0
          }
        }
      },
      pageable: {
        type: Boolean,
        default: true
      },
      stripe: {
        type: Boolean,
        default: false
      },
      selection: {
        type: Boolean,
        default: false
      },
      dialog: {
        type: Boolean,
        default: false
      },
      fixedHeader: {
        type: Boolean,
        default: false
      },
      offsetLeft: {
        type: Number,
        default: 0
      },
      scrollY: Boolean,
      beforeDraws: {
        type: Array,
        default: () => []
      },
      afterDraws: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      fixedRight () {
        return (this.operation && this.operation.options && this.operation.options.length > 0)
      },
      hScrollStyle () {
        if (this.dialog) {
          return null
        }
        let obj = { left: `${this.scrollOffsetLeft}px`, bottom: this.pageable ? '44px' : 0 }
        if (this.fixedHeader) {
          obj.width = '1280px'
        } else {
          obj.right = '16px'
        }
        return obj
      },
      editCellStyle () {
        let { left, top, width } = this.editPosition
        return {
          left: `${left + 1}px`,
          top: `${top}px`,
          width: `${width - 2}px`,
          height: `${this.rowHeight - 2}px`
        }
      },
      mode () {
        return this.options && this.options.mode === 'edit'
      }
    },
    data () {
      const isNew = isErp2()
      return {
        rowHeight: (this.options.config && this.options.config.rowHeight) || (isNew ? 32 : rowHeight),
        config: {
          ieNewLayout: isNew,
          btnColor: isNew ? '#8b60f0' : btnColor,
          headerColor: isNew ? '#f2f5ff' : headerColor,
          headerTextColor: isNew ? '#2e3038' : headerTextColor,
          headerBorderColor: isNew ? '#dddef0' : lineColor,
          tableTextColor: isNew ? '#1c1e23' : tableTextColor,
          borderColor: isNew ? '#dddef0' : lineColor,
          activeRowColor: isNew ? '#ebefff' : activeRowColor
        },
        scrollOffsetLeft: 176 + this.offsetLeft,
        cHeight: DEFAULT_HEIGHT,
        resizeThrottle: null,
        isActivated: false,
        tooltip: {
          content: '',
          left: 0,
          top: 0,
          show: false,
          isLast: false
        },
        headerTip: {
          content: '',
          left: 0,
          top: 0,
          show: false
        },
        editPosition: {
          top: -3000,
          left: -3000,
          text: '',
          width: 0
        },
        showDivideTag: false,
        showDivideLine: false,
        prevPage: 1
      }
    },
    methods: {
      windowResize () {
        this.scroll.disy = 0
        this.scroll.disx = 0
        this.setTooltipPosition()
        this.hScrollbar.style.left = 0
        this.vScrollbar.style.top = 0
        this.initScroll()
        this.calculate()
      },
      handleTabClick (path) {
        // 切换模块时重绘 canvas
        if (path && this.$route && path.split('?')[0] === this.$route.path && !this._inactive) {
          this.setCanvasWidth()
        }
      },
      handleSwitchMenu (width) {
        this.scrollOffsetLeft = width + 16 + this.offsetLeft
        this.$emit('switch-menu', width)
      },
      resetEditCell () {
        this.editPosition = {
          top: -3000,
          left: -3000,
          text: '',
          width: 0
        }
      },
      setCanvasWidth () {
        this.$nextTick(() => {
          this.setCanvas()
          this.initScroll()
          this.calculate()
        })
      },
      clearCurrentChange () {
        this.scroll.disx = 0
        this.$refs.hScrollbar.style.left = 0
        this.clearCurrentStatus()
      },
      clearCurrentStatus () {
        this.checkedRow = []
        this.emitChangeSelect()
        this.subCurrentChange(-1, -1)
        this.setTooltipPosition()
        if (this.prevPage !== this.page.currentPage) {
          this.clearHScroll()
          this.prevPage = this.page.currentPage
        }
      },
      // 清除滚动位置
      clearHScroll () {
        this.scroll.disy = 0
        this.activeRowIndex = null
        this.moveRowIndex = null
        this.$refs.vScrollbar.style.top = 0
      },
      reloadData () {
        this.isPaintImage = true
        this.cachedImages = {}
        this.clearCurrentStatus()
        this.resetEditCell()
        this.integrateData()
        this.initScroll()
        this.calculate()
      },
      // 外部控制列是否显示
      setTableColumns (option) {
        // 外部传进来的 width 合并到 colWidthMap
        if (option) {
          let conf = Object.keys(option).reduce((s, v) => {
            if (option[v].width) {
              s[v] = parseInt(option[v].width)
            }
            return s
          }, {})
          Object.assign(this.colWidthMap, conf)
        }
        this.clearCurrentChange()
        this.integrateData(true)
        this.initScroll()
        this.calculate()
      },
      // 返回排序后的原数组，与 el-table 保持 api 一致
      tableData () {
        return this.flatData.map(v => ({ ...this.data[v._index - 1] }))
      },
      // 重新渲染指定行的本地数据
      loadLocalData (opt) {
        if (opt && opt.row) {
          this.data[opt.index] = opt.row
        }
        this.setCanvas()
        this.integrateData(true)
        this.calculate()
        console.log('canvas reload')
      },
      showSlotToolTip (val = true) {
        this.slotTooltip.show = val
      },
      // canvas 字体调大后，日期列宽度+8
      adjustColWidth (arr) {
        if (arr && arr.length && !this.adjustCol) {
          this.adjustCol = true
          arr.forEach(v => {
            if (DATE_FILTERS.includes(v.filter)) {
              v.width += 8
            }
          })
        }
      },
      toggleRowSelection (cb) {
        if (cb && typeof cb === 'function') {
          this.$nextTick(_ => {
            let arr = cb(this.data || [])
            if (Array.isArray(arr)) {
              const res = []
              let selectIndexArr = []
              const flatData = this.flatData
              arr.forEach((v, i) => {
                if (v) {
                  let row = flatData[i]
                  if (!row._disabledCheck) {
                    res.push({ _index: row._index, _gtableuuid: row._gtableuuid })
                    selectIndexArr.push(row._index)
                  }
                }
              })
              this.checkedRow = res
              this.emitChangeSelect('row', selectIndexArr, [])
              this.paint()
            }
          })
        }
      }
    },
    created () {
      getHeight = getHeight.bind(this)
      DEFAULT_HEIGHT = getHeight(headerHeight)
      // 避免放在computed创建，会computed watcher
      this.getButtonOptions = getKeys(this.buttonOptions)
      this.getImageOptions = getKeys(this.imageOptions)
      this.getCheckedOptions = getKeys(this.checkedOptions)
      this.getUploadOptions = getKeys(this.uploadOptions)
      this.getLayerColumnOptions = getKeys(this.layerColumnOptions)
      this._calculateAuthPlugin = canavsCalculateAuthPlugin(this)
    },
    mounted () {
      const h = parseInt(this.height)
      this.prevPage = this.page.currentPage
      if (this.options.headerHeight) {
        this.cHeight = h < 32 ? getHeight(this.options.headerHeight) : h
      } else {
        this.cHeight = h < 32 ? DEFAULT_HEIGHT : h
      }
      this.resizeDebounce = debounce(this.windowResize, 200)
      window.addEventListener('resize', this.resizeDebounce)
      this.$bus.$on('TAB_CLICK', this.handleTabClick)
      this.$bus.$on('SWITCH_MENU', this.handleSwitchMenu)
      this.$nextTick(() => {
        if (this.column.length > 0) {
          this.$refs.canvasBox.style.borderColor = this.config.borderColor
        }
        this.getDom()
        this.integrateData()
        this.initScroll()
        this.calculate()
        this.canvasEvents()
        this.isActivated = true
      })
    },
    activated () {
      if (this.isActivated) {
        setTimeout(() => {
          this.initScroll()
          this.calculate()
          !this.options.autoFocus && this.canvas.focus()
        })
      }
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeDebounce)
      document.removeEventListener('keydown', this.handleKeyDown)
      this.$bus.$off('TAB_CLICK', this.handleTabClick)
      this.$bus.$off('SWITCH_MENU', this.handleSwitchMenu)
    },
    watch: {
      height (val) {
        const h = parseInt(val)
        if (this.options.headerHeight) {
          this.cHeight = h < 32 ? getHeight(this.options.headerHeight) : h
        } else {
          this.cHeight = h < 32 ? DEFAULT_HEIGHT : h
        }
        this.$nextTick(() => {
          this.initScroll()
          this.calculate()
        })
      },
      data () {
        this._calculateAuthPlugin && this._calculateAuthPlugin.crateBtnDisabledRowsIter()
        this.reloadData()
        this.canvasBox && (this.canvasBox.style.borderColor = this.config.borderColor)
      },
      column (val) {
        this.adjustColWidth(val)
        this.setTableColumns()
        this.canvasBox && (this.canvasBox.style.borderColor = this.config.borderColor)
      },
      scrollY () {
        this.initScroll()
        this.calculate()
      },
      scrollOffsetLeft () {
        if (!this._inactive) {
          this.setCanvasWidth()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .box {
    width: 100%;
    height: 612px;
    position: relative;
    /* 强行开启GPU加速 */
    transform: translate3d(0, 0, 0.001);
  }

  .canvasBox {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    border: 1px solid transparent;
    border-radius: var(--g-table-border-radius);
    user-select: none;
  }

  .box canvas {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
  }

  .input-content {
    margin: 0;
    outline: none;
    padding: 0 6px;
    top: -3000px;
    left: -3000px;
    border: none;
    color: #000000;
    border-radius: 0;
    font-size: 13px;
    position: absolute;
    background-color: #fefadc;
    z-index: 10;
    box-sizing: border-box;
    height: 27px;
    overflow-x: hidden;
    overflow-y: auto;
    word-break: break-all;
    letter-spacing: 0.3px;
  }

  .hScroll {
    height: 10px;
    position: fixed;
    z-index: 10;
    background-color: #ffffff;
    &-dialog {
      position: relative;
      height: 10px;
    }
  }

  .hScrollBar {
    user-select: none;
    height: 100%;
    // background-color: var(--g-color-primary);
    border-radius: 5px;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--g-table-scrollbar-thumb-color);
    // opacity: 0.4;
    &:hover {
      background-color: var(--g-table-scrollbar-thumb-hover-color);
      // opacity: 0.6;
    }
  }

  .vScroll {
    width: 10px;
    height: 100%;
    position: absolute;
    top: 32px;
    right: 0;
    &-dialog {
      width: 10px;
      .vScrollBar {
        width: 10px !important;
      }
    }
  }

  .vScrollBar {
    user-select: none;
    width: 10px;
    // background-color: var(--g-color-primary);
    border-radius: 5px;
    cursor: pointer;
    position: absolute;
    right: 0;
    z-index: 9;
    background-color: var(--g-table-scrollbar-thumb-color);
    // opacity: 0.4;
    &:hover {
      background-color: var(--g-table-scrollbar-thumb-hover-color);
      // opacity: 0.6;
    }
  }

  // .vScrollBar.scrolling {
  //   opacity: 1;
  // }

  .divideTag {
    width: 8px;
    position: absolute;
    left: 0;
    top: 0;
    height: 33px;
    cursor: col-resize;
    background: transparent;
    user-select: none;
    &::before {
      content: '';
      position: absolute;
      left: 2px;
      top: 0;
      height: 100%;
      width: 4px;
      background: #d00000;
      user-select: none;
    }
  }

  .divideLine {
    user-select: none;
    width: 1px;
    background: #d00000;
    min-height: 60px;
    position: absolute;
    left: 4px;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-canvas-table/canvas-table.vue